import { render, staticRenderFns } from "./ModalUserDetails.vue?vue&type=template&id=755d8608&scoped=true"
import script from "./ModalUserDetails.vue?vue&type=script&lang=js"
export * from "./ModalUserDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalUserDetails.vue?vue&type=style&index=0&id=755d8608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755d8608",
  null
  
)

export default component.exports